export default __webpack_public_path__ + "static/media/MP5_7.d6867c56.png";